$(document).ready(function(){

    // Steps instruction slider
    const showedItemsNum = 4 // TODO: Add this as data-show-item-number and add in the admin settings
    const items = $('[data-step-instruction] .page-aftersale__instruction').length
    const isDots = items > showedItemsNum ? true : false

    $('[data-step-instruction]').slick({
        slidesToShow: showedItemsNum,
        slidesToScroll: showedItemsNum,
        draggable: false,
        dots: isDots,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    adaptiveHeight: true
                }
            }
        ]
    })

    let select = s => document.querySelector(s),
        selectAll = s => document.querySelectorAll(s),
        orderDetailsTemplate = '',
        orderData = {},
        evaluatedNewOrderData = {},
        updatedEvaluatedNewOrderData = {},
        updatedFilteredProductsData = {},
        createOrderProductsData = {},
        uploadedImageArr = [],
        formBlockItemsCount = 0,
        orderCount = 0,
        client

    const fieldInput = selectAll('.field__input'),
        orderNumberInput = select('[data-order-number]'),
        searchOrderButton = select('[data-search-button]'),
        evaluateNewOrderButton = select('[data-evaluate-new-order-button]'),
        createOrderButton = select('[data-create-order-button]'),
        notMyOrderButton = select('[data-not-my-order-button]'),
        uploadImageButton = select('[data-upload-image]'),
        deliveryAddressOptions = selectAll('input[name="opt_address"]'),
        uploadedLabelContainer = select('[data-uploaded-label-container]'),
        uploadedImageContainer = select('[data-uploaded-images-container]'),
        initImageUpload = select('[data-uploaded-button]'),
        addProductButton = select('[data-add-product-button]'),
        formBlockItems = select('[data-form-block-items]'),
        orderNumberBox = selectAll('[data-order-number-box]'),
        errorMessage = selectAll('[data-error-message]'),
        backButtons = selectAll('[data-back-button]'),
        submitReturnInformationButton = select('[data-submit-return-information]'),
        stepContainerActiveCLass = 'step-container--active'

    const isEmpty = str => !str.trim().length
    // const serverUrl = 'https://oa-test.ecoflow.com' // DEV
    const serverUrl = 'https://oa.ecoflow.com' // PROD
    const headersConfig = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'Token': '2c41ca28b6fced883317b5acc2e03866' // DEV
        'Token': 'AK5cUbb2CHYOW3IoVjM6DLYGqM9tLJCb' // PROD
    }

    // Float label animation
    function fieldLabelFloat() {
        if(isEmpty(this.value)) this.closest('.field').classList.remove('field--show-floating-label')
        else this.closest('.field').classList.add('field--show-floating-label')
    }
    fieldInput.forEach(input => { input.addEventListener('keyup', fieldLabelFloat) })

    // Update quantity base on Product name
    function updateQuantityOptions(){
        const selectIndex = this.getAttribute('data-select-product-name')
        const selectValue = this.value
        const selectQuantityOptions = selectAll(`[name="quantity_${selectIndex}"] option`)
        const selectedQuantityOptions = selectAll(`[name="quantity_${selectIndex}"] option[data-option-name="${selectValue}_0"]`)

        selectQuantityOptions.forEach(option => {
            option.classList.add('hide')
            option.selected = false
        })
        selectedQuantityOptions.forEach(option => option.classList.remove('hide'))
    }

    async function getSalesOrderOverview(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.getSalesOrderOverview`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function listSalesOrdersOverview(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.listSalesOrdersOverview`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function evaluateNewOrder(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.evaluateNewOrder`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function createCustomerOrder(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.createOrder`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function generateReturnLabel(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.generateReturnLabel`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function getProvinces(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.getProvinces`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function getAliOssTokens(data) {
        const res = await fetch(`${serverUrl}/api/afterSales.customerOrder.getAliOssCredentials`, {
            method: 'POST',
            headers: headersConfig,
            body: JSON.stringify(data)
        })
        const res_data = await res.json()
        return res_data
    }

    async function putObject(data,fname,inputHidden,last,e) {
        const res = await client.put(
          "exampledir/uploaded-"+fname,
          data
        );
        uploadedImageArr.push(res.url)
        inputHidden.value = JSON.stringify(uploadedImageArr)
        if(last){
           uploadedImageArr = [];
           setTimeout(function(){ updateProductsData() }, 500);
        }
        return res.url
    }

    function isUnderWarranty(createAtDate) {
        const warrantyDaysConvered = 60
        const dateBought = new Date(createAtDate)
        const dateToday = new Date()
        let hasWarranty = false
        let numDaysBetween = function(dateToday, dateBought) {
            let diff = Math.abs(dateToday.getTime() - dateBought.getTime())
            return diff / (1000 * 60 * 60 * 24)
        }

        if(numDaysBetween(dateToday,dateBought) <= warrantyDaysConvered) hasWarranty = true

        return hasWarranty
    }

    function checkRequiredFields(containerEl) {
        const requiredFields = selectAll(`${containerEl} [required]`)
        let isEmptyField = true

        requiredFields.forEach(field => {
            if (!isEmptyField) return
            if(isEmpty(field.value)) isEmptyField = false
        })

        return isEmptyField
    }

    function toggleReturnInformationAddress() {
        const optionSameAddress = select('[data-confirm-information-box]')
        const optionNewAddress = select('[data-new-address-form]')
        const requiredFields = selectAll('[data-new-address-form] [required]')
        const requiredSelectFields = selectAll('[data-new-address-form] select[required]')
        deliveryAddressOptions.forEach(option => option.addEventListener('change', _change))

        function _toggleSubmit() {
            if(checkRequiredFields('[data-new-address-form]')) submitReturnInformationButton.classList.remove('isDisabled')
            else submitReturnInformationButton.classList.add('isDisabled')
        }

        function _change() {
            const thisID = this.getAttribute('id')

            if(thisID == 'new_address') {
                _toggleSubmit()
                optionSameAddress.classList.add('hide')
                optionNewAddress.classList.remove('hide')
                // Check if all required fields are filled then enable Submit button
                requiredFields.forEach(option => option.addEventListener('keyup', _toggleSubmit))
                requiredSelectFields.forEach(select => select.addEventListener('change', _toggleSubmit))

                // clear all fields
                requiredFields.forEach(field => field.value = '')
                requiredSelectFields.forEach(select => select.value = '')

                // remove field--show-floating-label class in all field
                requiredFields.forEach(field => {
                    // check first if has field--show-floating-label class and not have select-style class in children
                    if(field.closest('.field').classList.contains('field--show-floating-label') && !field.closest('.field').querySelector('.select-style')) {
                        field.closest('.field').classList.remove('field--show-floating-label')
                    }
                })
            } else {
                optionSameAddress.classList.remove('hide')
                submitReturnInformationButton.classList.remove('isDisabled')
                optionNewAddress.classList.add('hide')
            }
        }
    }

    function isOrderNumberValid(jsonData, fromStep) {
        const codeStr = jsonData.code ? jsonData.code.toString() : '0'
        const data = jsonData.data
        const hasError = jsonData.message

        if(hasError) {
            errorMessage.forEach(message => message.innerText = jsonData.message)
            showPopup('popup-error-message')
        } else {
            switch(codeStr) {
                case '0':
                    // valid
                    if(fromStep == 0) {

                        orderDetailsTemplate = data.map((data, index) => {

                            orderData = {
                                orderNumber: data.channelOrderId,
                                channel: data.channel,
                                purchasedDate: data.createdAt,
                                purchasedDateStr: new Date(data.createdAt),
                                products: data.products.map(product => {
                                    const productName = product.name != undefined ? product.name : product.skuCode
                                    return ' ' + productName
                                }),
                                productsTotal: data.products.length,
                                customerName: data.contact,
                                phone: data.phone != null ? data.phone : '-',
                                email: data.email != null ? data.email : '-'
                            }

                            let orderDetailTemplate = `
                            <div class="order-information-content__box" data-index="${index}" data-purchased-order-number="${orderData.orderNumber}" data-purchased-date="${orderData.purchasedDate}" data-order-box>
                                <dl class="row">
                                    <div class="dl-item col-6 col-md-12">
                                    <dt class="dt-order-number">Order Number</dt>
                                        <dd class="dd-order-number">${orderData.orderNumber}</dd>
                                    </div>
                                    <div class="dl-item col-6 col-md-12">
                                        <dt class="dt-channel">Channel</dt>
                                        <dd class="dd-channel">${orderData.channel}</dd>
                                    </div>
                                    <div class="dl-item col-12">
                                        <dt class="dt-purchase">Purchase Date</dt>
                                        <dd class="dd-purchase">${orderData.purchasedDateStr.toString()}</dd>
                                    </div>
                                    <div class="dl-item col-12">
                                        <dt class="dt-overview">Overview</dt>
                                        <dd class="dd-overview">Includes ${orderData.products} ${orderData.productsTotal > 3 ? '...' : ''} , ${orderData.productsTotal} ${orderData.productsTotal > 1 ? 'items' : 'item'} in total</dd>
                                    </div>
                                    <div class="dl-item col-6 col-md-12">
                                        <dt class="dt-customer-name">Customer Name</dt>
                                        <dd class="dd-customer-name text-capitalize">${orderData.customerName.toLowerCase()}</dd>
                                    </div>
                                    <div class="dl-item col-6 col-md-12">
                                        <dt class="dt-phone">Phone</dt>
                                        <dd class="dd-phone">${orderData.phone}</dd>
                                    </div>
                                    <div class="dl-item col-12">
                                        <dt class="dt-email">Email</dt>
                                        <dd class="dd-email">${orderData.email}</dd>
                                    </div>
                                </dl>
                            </div>`

                            return orderDetailTemplate
                        })

                        // // get purchase date
                        // const orderPurchaseDate = data.map(data => data.createdAt)

                        select('[data-step="0"]').classList.remove(stepContainerActiveCLass)
                        select('[data-step="1"]').classList.add(stepContainerActiveCLass)
                        select('[data-step="1"] [data-content-box]').innerHTML = orderDetailsTemplate.join('')

                        window.scroll({
                            top: select('.page-aftersale__section').offsetTop,
                            behavior: 'smooth'
                        })

                        _toggleConfirmButton()
                        setTimeout(()=> _orderSelection() ,250)

                        function _orderSelection() {
                            selectAll('[data-order-box]').forEach(orderBox => {
                                orderBox.addEventListener('click', function(){
                                    this.classList.toggle('active')
                                    _toggleConfirmButton()
                                })
                            })
                        }

                        function _toggleConfirmButton() {
                            const activeOrderBoxCount = selectAll('.active[data-order-box]').length
                            if(activeOrderBoxCount > 0) evaluateNewOrderButton.classList.remove('isDisabled')
                            else evaluateNewOrderButton.classList.add('isDisabled')
                        }

                    } else if(fromStep == 1) {

                        // go to step 2
                        select('[data-step="1"]').classList.remove(stepContainerActiveCLass)
                        select('[data-step="2"]').classList.add(stepContainerActiveCLass)

                        // check if evaluatedNewOrderData has no data yet, then add data
                        if(Object.keys(evaluatedNewOrderData).length === 0) evaluatedNewOrderData = data

                        // update products data
                        else {
                            const updatedProductsData = data.products.map(product => product)
                            const combinedProductsArray = [...evaluatedNewOrderData.products, ...updatedProductsData]

                            const updatedSkuAllocationData = data.skuAllocation.map(sku => sku)
                            const combinedSkuAllocationArray = [...evaluatedNewOrderData.skuAllocation, ...updatedSkuAllocationData]

                            evaluatedNewOrderData = {
                                ...evaluatedNewOrderData,
                                "products": combinedProductsArray,
                                "skuAllocation": combinedSkuAllocationArray
                            }
                        }

                    } else if(fromStep == 2) {
                        // go to step 3
                        select('[data-step="2"]').classList.remove(stepContainerActiveCLass)
                        select('[data-step="3"]').classList.add(stepContainerActiveCLass)
                        const evaludatedData = evaluatedNewOrderData

                        const returnInfoData = {
                            customerName: evaludatedData.contact,
                            phone: evaludatedData.phone != null ? evaludatedData.phone : '-',
                            orderNumber: evaludatedData.channelOrderId,
                            address: evaludatedData.address,
                            city: evaludatedData.city,
                            province: evaludatedData.province,
                            postalCode: evaludatedData.postalCode,
                        }

                        let confirmReturInformtionTemplate = `
                            <dl class="row">
                                <div class="dl-item col-6 col-md-12">
                                    <dt>Customer Name</dt>
                                    <dd class="text-capitalize">${returnInfoData.customerName.toLowerCase()}</dd>
                                </div>
                                <div class="dl-item col-6 col-md-12">
                                    <dt>Phone</dt>
                                    <dd>${returnInfoData.phone}</dd>
                                </div>
                                <div class="dl-item col-12">
                                    <dt>Detail Address</dt>
                                    <dd>${returnInfoData.address}</dd>
                                </div>
                                <div class="dl-item col-6 col-md-12">
                                    <dt>City</dt>
                                    <dd>${returnInfoData.city}</dd>
                                </div>
                                <div class="dl-item col-6 col-md-12">
                                    <dt>Province</dt>
                                    <dd>${returnInfoData.province}</dd>
                                </div>
                                <div class="dl-item col-6 col-md-12">
                                    <dt>Zip Code</dt>
                                    <dd>${returnInfoData.postalCode}</dd>
                                </div>
                            </dl>`

                        toggleReturnInformationAddress()
                        select('[data-confirm-information-box]').innerHTML = confirmReturInformtionTemplate
                        updateProvinceOptions()

                    } else if(fromStep == 3) {
                        // go to step 4
                        select('[data-step="3"]').classList.remove(stepContainerActiveCLass)
                        select('[data-step="4"]').classList.add(stepContainerActiveCLass)
                        createOrderProductsData = data

                        // clear data-download-link html if any
                        if(select('[data-download-link]')) select('[data-download-link]').innerHTML = ''

                        // show data-download-link button
                        if(select('[data-generate-return-label]').classList.contains('hide')) select('[data-generate-return-label]').classList.remove('hide')

                        // add event listener to generate return label button
                        select('[data-generate-return-label]').addEventListener('click', submitReturnLabelData)
                    } else if(fromStep == 4) {
                        const returnLabelUrl = data.returnLabel
                        const returnLabelTemplate = `<a href="${returnLabelUrl}" class="hide btn btn-primary btn-pill text-capitalize" target="_blank" rel="noopener noreferrer" data-download-returl-label>Generate & Download Label</a>`

                        // Download return label
                        select('[data-download-link]').insertAdjacentHTML('beforeend', returnLabelTemplate)

                        setTimeout(() => {
                            select('[data-download-returl-label]').click()
                            select('[data-download-returl-label]').classList.remove('hide')
                            select('[data-generate-return-label]').classList.add('hide')
                        }, 250)
                    } else {
                        return
                    }
                    break
                case '204':
                    // not a valid order number
                    orderNumberBox.forEach(box => box.innerText = orderNumberInput.value)
                    showPopup('popup-not-valid-order-number')
                    break
                default:
                    return
            }
        }
    }

    let tokenData = {
        "type": "api2",
        "args": []
    }
    getAliOssTokens(tokenData)
        .then((resp) => {
            const data = resp.data
            client = new OSS({
                region: data.region,
                accessKeyId: data.accessKeyId,
                accessKeySecret:  data.accessKeySecret,
                stsToken: data.stsToken,
                bucket:  data.bucket,
            })
    })

    function toggleAddProductButton(action) {

        function _updateProductTileCount() {
            selectAll('[data-form-block-items] .form-block').forEach((formBlock, index) => {
                formBlock.querySelector('[data-product-title-count]').innerHTML = index + 1
            })
        }

        function _toggleRemoveButton() {
            selectAll('[data-form-block-items] .form-block').forEach((formBlock, index) => {
                const indexValue = index + 1
                const removeButton = formBlock.querySelector('[data-remove-product-button]')

                if(index > 0 && formBlockItemsCount == indexValue) removeButton && removeButton.classList.remove('hide')
                else removeButton && removeButton.classList.add('hide')
            })
        }

        if(action == 'add') {
            select('[data-add-product-count]').innerHTML = formBlockItemsCount + 2
            formBlockItemsCount = formBlockItemsCount + 1
        }
        else {
            select('[data-add-product-count]').innerHTML = formBlockItemsCount
            formBlockItemsCount = formBlockItemsCount - 1
            _updateProductTileCount()
        }

        _toggleRemoveButton()
        checkMalDescription()

        const productsCount = evaluatedNewOrderData.products.length
        if(formBlockItemsCount == productsCount) addProductButton.classList.add('hide')
        else addProductButton.classList.remove('hide')
    }

    function removeProduct() {
        this.closest('.form-block').remove()
        toggleAddProductButton('remove')
    }

    function addRequestFormProduct() {

        evaluatedNewOrderData.products && evaluatedNewOrderData.products.forEach((product, index) => {
            const productNameOptions = evaluatedNewOrderData.products.map((product, index) => {
                const productName = product.name != undefined ? product.name : product.skuCode
                return `<option value="${productName}" data-product-index=${index} ${index == formBlockItemsCount ? 'selected' : ''}>${productName}</option>`
            })
            const productQuantityOptions = evaluatedNewOrderData.products.map((product, index) => {
                const producQantity = product.quantity
                const producName = product.name
                let options = []

                for (let i = 1; i <= producQantity; i++) {
                    options.push(`<option class="${index > 0 ? 'hide' : ''}" value="${i}" data-option-name="${producName}_${formBlockItemsCount}" ${index == formBlockItemsCount ? 'selected' : ''}>${i}</option>`)
                }

                return options
            })

            let formBlockTemplate = `
            <div class="form-block">
                <div class="form-block__header">
                    <p class="form-block__title">Product <span data-product-title-count>${formBlockItemsCount + 1}</span></p>
                    <!-- ${formBlockItemsCount > 0 ? '<span class="form-block__remove-button" data-remove-product-button>Remove</span>' : ''} -->
                </div>
                <div class="form-row">
                    <div class="col-md-6">
                        <div class="field field--show-floating-label">
                            <div class="field__input-wrapper">
                                <label class="field__label">Product Name*</label>
                                <div class="select-style">
                                    <select name="product_name_${formBlockItemsCount}" data-select-product-name="${formBlockItemsCount}" disabled>
                                        ${productNameOptions}
                                    </select>
                                    <span class="select-style__arrow"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="field field--show-floating-label">
                            <div class="field__input-wrapper">
                                <label class="field__label">Quantity*</label>
                                <div class="select-style">
                                    <select name="quantity_${formBlockItemsCount}" disabled>
                                        ${productQuantityOptions.join('')}
                                    </select>
                                    <span class="select-style__arrow"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6">
                        <div class="field">
                            <div class="field__input-wrapper">
                                <label class="field__label">Return Reasons*</label>
                                <textarea type="text" placeholder="Return Reasons*" name="malfunction_description_${formBlockItemsCount}" class="field__input" data-malfunction_description></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label data-uploaded-label-container="${formBlockItemsCount}" >
                            <input name="aliOssUploadFile${formBlockItemsCount}" class="aliOssUploadFile" type="file" hidden data-upload-image="${formBlockItemsCount}" block-index="${formBlockItemsCount}" />
                            <div class="upload-image-area" data-uploaded-label="${formBlockItemsCount}" >
                                <span class="icon-upload"></span>
                                <span class="label">Upload image</span>
                                <p>Select image file (JPG, PNG, BMP, and more)</p>
                            </div>
                            <div class="field field--show-floating-label hide" data-uploaded-images="${formBlockItemsCount}" >
                                <div class="field__input-wrapper">
                                    <label class="field__label">Image Uploaded</label>
                                    <div class="uploaded-images">
                                        <div class="uploaded-images__content-list">
                                            <ul>
                                                <li><span class="tick-btn"></span> <span class="uploaded-filename">Image file name</span></li>
                                                <li><span class="tick-btn"></span> <span class="uploaded-filename">Image file name</span></li>
                                                <li><span class="tick-btn"></span> <span class="uploaded-filename">Image file name</span></li>
                                                <li><span class="tick-btn"></span> <span class="uploaded-filename">Image file name</span></li>
                                            </ul>
                                        </div>
                                        <span class="upload-image-btn" data-uploaded-button="${formBlockItemsCount}">Upload image</span>
                                    </div>
                                </div>
                            </div>
                        </label>
                        <input type="hidden" name="malfunction_images_${formBlockItemsCount}">
                    </div>
                </div>
            </div>`

            formBlockItems.insertAdjacentHTML('beforeend', formBlockTemplate)
            formBlockItemsCount++
        })

        // toggleAddProductButton('add')
        setTimeout(()=> {
            selectAll('.aliOssUploadFile').forEach(input => { input.addEventListener('change',uploadImageButtonFunc) })
            selectAll('.field__input').forEach(input => { input.addEventListener('keyup', fieldLabelFloat) })
            selectAll('[data-malfunction_description]').forEach(input => { input.addEventListener('keyup', checkMalDescription) })
            selectAll('[data-select-product-name]').forEach(select => select.addEventListener('change', updateQuantityOptions))
            selectAll('[data-remove-product-button]').forEach(removeButton => removeButton.addEventListener('click', removeProduct))
        }, 250)
        createOrderButton.classList.add('isDisabled');
    }

    function loadingButton(selector, boolean) {
        const thisButon = select(selector)
        const btnLoaderTemplate = '<span class="btn-loader"></span>'

        if(boolean) {
            thisButon.classList.add('isDisabled')
            thisButon.insertAdjacentHTML('beforeend', btnLoaderTemplate)
        } else {
            thisButon.classList.remove('isDisabled')
            select('.btn-loader').remove()
        }
    }

    function searchOrderNumber(e) {
        e.preventDefault()
        const orderNumberValue = orderNumberInput.value

        // clear evaluatedNewOrderData
        evaluatedNewOrderData = {}

        if(!isEmpty(orderNumberValue)) {

            loadingButton('[data-search-button]', true)

            let listSalesOrdersOverviewData = {
                "type": "api2",
                "args": [{
                    "channelOrderId": orderNumberValue.toString(),
                    "market": "NA"
                }]
            }

            listSalesOrdersOverview(listSalesOrdersOverviewData).then(data => {
                isOrderNumberValid(data, 0)
                loadingButton('[data-search-button]', false)
            })
        }
        return
    }

    function confirmOrderDetails(e) {
        e.preventDefault()
        let orderNumberValueArray = []
        const orderPurchaseDate = select('.active[data-order-box]').getAttribute('data-purchased-date')
        const orderNumberValue = selectAll('.active[data-order-box]').forEach(orderBox => {
            orderNumberValueArray.push(orderBox.getAttribute('data-purchased-order-number'))
        })
        let doneEvaluatingOrderTimer

        // clear evaluatedNewOrderData
        evaluatedNewOrderData = {}

        if(isUnderWarranty(orderPurchaseDate)) {
            orderNumberValueArray.forEach((orderNumber, index) => {
                if(!isEmpty(orderNumber)) {

                    // reset step 2
                    formBlockItemsCount = 0
                    formBlockItems.innerHTML = ''

                    loadingButton('[data-evaluate-new-order-button]', true)

                    let evaluateNewOrderData = {
                        "type": "api2",
                        "args": [{
                            "channelOrderId": orderNumber,
                             "market": "NA",
                            "type": "return"
                        }]
                    }

                    evaluateNewOrder(evaluateNewOrderData).then(data => {
                        isOrderNumberValid(data, 1)
                        loadingButton('[data-evaluate-new-order-button]', false)

                        clearTimeout(doneEvaluatingOrderTimer)
                        doneEvaluatingOrderTimer = setTimeout(function() {
                            // done EvaluatingOrder, then add request form products
                            addRequestFormProduct()
                        }, 250);
                    })
                }
            })

        } else {
            const orderIndex = select('.active[data-order-box]').getAttribute('data-index')
            select('#popup-exceed-warranty [data-content-box]').innerHTML = orderDetailsTemplate[orderIndex]
            showPopup('popup-exceed-warranty')
        }
    }

    function createOrder(e) {
        e.preventDefault()

        const selectedDeliveryAddressOptionId = select('input[name="opt_address"]:checked').getAttribute('id')

        if(selectedDeliveryAddressOptionId == 'new_address') {
            const newName = select('[data-new-contact-name]').value
                newPhoneNumber = select('[data-new-phone-number]').value,
                newAddress = select('[data-new-address]').value,
                newCity = select('[data-new-city]').value,
                newProvince = select('[data-province]').value,
                newPostalCode = select('[data-postal-code]').value

            updatedFilteredProductsData = {
                ...updatedFilteredProductsData,
                "contact": newName,
                "phone": newPhoneNumber,
                "address": newAddress,
                "city": newCity,
                "province": newProvince,
                "postalCode": newPostalCode
            }

            setTimeout(()=>{ _createOrderNow() },1000)
        } else {
            updatedFilteredProductsData = {
                ...updatedFilteredProductsData,
                "contact": updatedEvaluatedNewOrderData.contact,
                "phone": updatedEvaluatedNewOrderData.phone,
                "address": updatedEvaluatedNewOrderData.address,
                "city": updatedEvaluatedNewOrderData.city,
                "province": updatedEvaluatedNewOrderData.province,
                "postalCode": updatedEvaluatedNewOrderData.postalCode
            }
            setTimeout(()=>{ _createOrderNow() },1000)
        }

        function _createOrderNow() {
            let createOrderData = {
                "type": "api2",
                "args": [updatedFilteredProductsData]
            }

            loadingButton('[data-submit-return-information]', true)
            createCustomerOrder(createOrderData).then(data => {
                isOrderNumberValid(data, 3)
                loadingButton('[data-submit-return-information]', false)
            })
        }

        return
    }

    function submitReturnLabelData(e) {
        e.preventDefault()
        const data = createOrderProductsData
        loadingButton('[data-generate-return-label]', true)

        let generateReturnLabelData = {
            "type": "api2",
            "args": [{
                "id": data.id,
                "type": "fedex",
                "phone": data.phone != null ? data.phone : '4172627911',
            }]
        }

        generateReturnLabel(generateReturnLabelData).then(data => {
            isOrderNumberValid(data, 4)
            loadingButton('[data-generate-return-label]', false)
        })

        return
    }

    function updateProvinceOptions() {
        const provinceSelectField = select('[data-province]')
        const isProvinceHasOptions = provinceSelectField.children.length

        function _setProvince(data) {
            const provinces = data.data.map(province => {
                return `<option value="${province.name}">${province.name}</option>`
            })
            provinceSelectField.insertAdjacentHTML('afterbegin', '<option value="">Select state</option>')
            provinceSelectField.insertAdjacentHTML('beforeend', provinces)
        }

        if(isProvinceHasOptions <= 0) {
            let provinceData = {
                "type": "api2",
                "args": [{
                  "country": "US"
                }]
            }
            getProvinces(provinceData).then(data => {
                // alphabetically arage provinceData data
                data.data.sort((a, b) => {
                    const provinceA = a.name.toUpperCase()
                    const provinceB = b.name.toUpperCase()
                    if (provinceA < provinceB) return -1
                    if (provinceA > provinceB) return 1
                    return 0
                })

                _setProvince(data)
            })
        }

        return
    }

    function updateProductsData() {
        let returnProductsIndex = []
        const updatedProductsData = evaluatedNewOrderData.products.map((v, i) => {
            const productIndex = i
            let newProducts = {...v}

            for (let formIndex = 0; formIndex < formBlockItemsCount;) {
                let productNameSelect = select(`[name="product_name_${formIndex}"]`)
                let selectedProductNameIndex = productNameSelect.options[productNameSelect.selectedIndex].getAttribute('data-product-index')
                let quantityValue = parseFloat(select(`[name="quantity_${formIndex}"]`).value)
                let malfunctionDescription = select(`[name="malfunction_description_${formIndex}"]`).value
                let malfunctionImages = select(`[name="malfunction_images_${formIndex}"]`).value
                let price = parseFloat(v.price)

                if(selectedProductNameIndex && productIndex == selectedProductNameIndex) {
                    returnProductsIndex.push(productIndex)
                    newProducts = {
                        ...v,
                        quantity: quantityValue,
                        malfunctionDescription: malfunctionDescription != '' ? malfunctionDescription : '',
                        malfunctionImages: malfunctionImages != '' ? JSON.parse(malfunctionImages) : [],
                        totalValue: price * quantityValue
                    }
                }
                formIndex++
            }

            return newProducts
        })


        updatedEvaluatedNewOrderData = {
            ...evaluatedNewOrderData,
            "products": updatedProductsData
        }

        // remove unselected product
        setTimeout(()=>{
            let filteredProductsData = updatedEvaluatedNewOrderData.products.filter((product, index) => returnProductsIndex.includes(index))

            updatedFilteredProductsData = {
                ...updatedEvaluatedNewOrderData,
                "products": filteredProductsData
            }
        }, 300)

        // update grand total value
        setTimeout(()=>{
            const productsCount = updatedFilteredProductsData.products.length
            const singleTotal = updatedFilteredProductsData.products[0].totalValue
            let updatedTotalValue = updatedFilteredProductsData.products.reduce(function(a, b) {
                return productsCount > 1 ? a + b.totalValue : singleTotal
            },0)

            updatedFilteredProductsData = {
                ...updatedFilteredProductsData,
                "totalValue": updatedTotalValue
            }
        }, 600)

        setTimeout(()=>{
            isOrderNumberValid(updatedFilteredProductsData, 2)
            loadingButton('[data-create-order-button]', false)
        }, 1000)
    }

    function uploadImageButtonFunc(e){
        var index = this.getAttribute('block-index');
        select(`[data-uploaded-label="${index}"]`).classList.add('hide')
        select(`[data-uploaded-images="${index}"]`).classList.remove('hide')
        select(`[data-uploaded-images="${index}"]`).querySelector('ul').innerHTML = '';
        var dataLength = this.files.length, i
        for (i = 0; i < dataLength; i++) {
            fileName = this.files[i].name;
            select(`[data-uploaded-images="${index}"]`).querySelector('ul').innerHTML += '<li><span class="tick-btn"></span> <span class="uploaded-filename">'+fileName+'</span></li>'
        }
    }

    function initImageUploadFunc(elem){
        var dataLength = (selectAll('[data-upload-image]').length-1), isLast = false;

        loadingButton('[data-create-order-button]', true)

        selectAll('[data-upload-image]').forEach(function(e,i){
            if(e.value !== ''){
                data = e.files[0];
                fileName = e.files[0].name;
                if(i === dataLength){
                    isLast = true;
                }
                putObject(data,fileName,select(`[name=malfunction_images_${i}]`),isLast,elem)
            }
            else{
                if(i === dataLength){
                    uploadedImageArr = [];
                    setTimeout(function(){ updateProductsData() }, 500);
                }
            }
        })
    }

    function checkMalDescription(){
        var enableButton = 0;
        var descLength = selectAll('[data-malfunction_description]').length
        selectAll('[data-malfunction_description]').forEach(function(e,i){
            if( e.value !== '' ){
                enableButton += 1;
            }
            if( i === (descLength-1) && enableButton === descLength){
                createOrderButton.classList.remove('isDisabled')
            }
            else{
                createOrderButton.classList.add('isDisabled')
            }
        })
    }

    searchOrderButton.addEventListener('click', searchOrderNumber)
    evaluateNewOrderButton.addEventListener('click', confirmOrderDetails)
    createOrderButton.addEventListener('click', initImageUploadFunc)
    submitReturnInformationButton.addEventListener('click', createOrder)
    addProductButton.addEventListener('click', addRequestFormProduct)
    notMyOrderButton.addEventListener('click', function() {
        orderNumberBox.forEach(box => box.innerText = select('.active[data-order-box]').getAttribute('data-purchased-order-number'))
        showPopup('popup-not-my-order')
    })

    backButtons.forEach(button => button.addEventListener('click', function() {
        const activeStepNumber = select('.step-container--active').getAttribute('data-step')
        const prevStepNumber = parseInt(activeStepNumber) - 1

        select(`[data-step="${activeStepNumber}"]`).classList.remove(stepContainerActiveCLass)
        select(`[data-step="${prevStepNumber}"]`).classList.add(stepContainerActiveCLass)
    }))

})